import { min, max } from '../utils';

const getNumberFromHex = (hex: string, start: number, double = false) => (double
  ? parseInt(`0x${hex.slice(start, start + 1)}${hex.slice(start, start + 1)}`, 16)
  : parseInt(`0x${hex.slice(start, start + 2)}`, 16));

// hex => rgba, rgb/rgba => rgba 其它保留 e.g. transparent
export const toRgba = (hex?: string, a?: number): string | undefined => {
  if (!hex) {
    return undefined;
  }
  // rgb(r, g, b) | rgba(r, g, b, a)
  if (hex.slice(0, 3) === 'rgb') {
    return a ? rgbSetA(hex, a) : hex;
  }
  // e.g. transparent
  if (hex[0] !== '#') {
    return hex;
  }
  // #abc -> #aabbcc | #abcf -> #aabbccff
  if (hex.length <= 5) {
    const r = getNumberFromHex(hex, 1, true);
    const g = getNumberFromHex(hex, 2, true);
    const b = getNumberFromHex(hex, 3, true);
    const x = a ?? (getNumberFromHex(hex, 4, true) + 1) / 256;
    return `rgba(${r}, ${g}, ${b}, ${(isNaN(x) ? 1 : x).toFixed(2)})`;
  }
  // #aabbcc | #aabbccff
  const r = getNumberFromHex(hex, 1);
  const g = getNumberFromHex(hex, 3);
  const b = getNumberFromHex(hex, 5);
  const x = a ?? (getNumberFromHex(hex, 7) + 1) / 256;
  return `rgba(${r}, ${g}, ${b}, ${(isNaN(x) ? 1 : x).toFixed(2)})`;
};

const rgbSetA = (rgba: string, a: number): string => {
  const list = rgba.split(',');
  const r = parseInt(list[0].split('(')[1], 10);
  const g = parseInt(list[1], 10);
  const b = parseInt(list[2].split(')')[0], 10);
  return `rgba(${r}, ${g}, ${b}, ${a.toFixed(2)})`;
};

// rgb => hex
export const toHex = (color: string) => {
  const rgb = color.split(',');
  const r = parseInt(rgb[0].split('(')[1], 10);
  const g = parseInt(rgb[1], 10);
  const b = parseInt(rgb[2].split(')')[0], 10);
  const a = rgb[3] ? parseFloat(rgb[3].split(')')[0]) : undefined;
  const hex = `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}${
    a ? (limit(a, 0, 1) * 256 - 1).toString(16) : ''}`;
  return hex;
};

const limit = (num: number, from: number, to: number) => min(max(num, from), to);
